export const ROUTES = {
  MIGRATION: 'migracao-de-dados',
  SETTINGS: 'configuracoes'
}
